<template>
    <div>
        <teleport to="#breadcrumb">
            <ul class="navbar-nav flex-row">
                <li>
                    <div class="page-header">
                        <nav class="breadcrumb-one" aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="javascript:;">Dashboard</a></li>
                                <li class="breadcrumb-item active" aria-current="page"><span>Cursos</span></li>
                            </ol>
                        </nav>
                    </div>
                </li>
            </ul>
        </teleport>
        <!-- Hero com busca estilo Udemy -->
        <section class="cursos-hero">
            <div class="cursos-hero-inner container">
                <h1 class="cursos-hero-title">Aprenda no seu ritmo</h1>
                <p class="cursos-hero-subtitle">Explore os cursos disponíveis.</p>
                <div class="cursos-hero-search-wrap">
                    <span class="cursos-hero-search-icon" aria-hidden="true">
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="11" cy="11" r="8"></circle>
                            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                        </svg>
                    </span>
                    <input
                        :value="cursoStore.headerSearchQuery"
                        @input="onSearchInput"
                        type="search"
                        class="cursos-hero-search-input"
                        placeholder="Buscar cursos..."
                        autocomplete="off"
                        aria-label="Buscar cursos"
                    />
                </div>
            </div>
        </section>

        <div class="faq container">
            <div class="faq-layouting layout-spacing">
                <div class="fq-comman-question-wrapper">
                    <div class="fq-article-section mt-3">
                        <!-- Loading State - Skeleton -->
                        <div v-if="cursoStore.loading" class="row cursos-index-skeleton">
                            <div
                                v-for="n in 8"
                                :key="n"
                                class="col-lg-3 col-md-6 mb-lg-0 mb-4"
                            >
                                <div class="skeleton-card">
                                    <div class="skeleton-card-image skeleton"></div>
                                    <div class="skeleton-card-body">
                                        <div class="skeleton skeleton-rating"></div>
                                        <div class="skeleton skeleton-title"></div>
                                        <div class="skeleton skeleton-text"></div>
                                        <div class="skeleton skeleton-text short"></div>
                                        <div class="skeleton-meta">
                                            <span class="skeleton skeleton-meta-item"></span>
                                            <span class="skeleton skeleton-meta-item"></span>
                                        </div>
                                        <div class="skeleton-footer">
                                            <span class="skeleton skeleton-badge"></span>
                                            <span class="skeleton skeleton-alunos"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Error State -->
                        <div v-else-if="cursoStore.error" class="text-center py-5">
                            <div class="alert alert-danger" role="alert">
                                <strong>Erro!</strong> {{ cursoStore.error }}
                            </div>
                            <button class="btn btn-primary mt-3" @click="cursoStore.fetchCursos()">
                                Tentar Novamente
                            </button>
                        </div>

                        <!-- Empty State -->
                        <div v-else-if="!cursoStore.loading && cursosFiltrados.length === 0" class="text-center py-5">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="64"
                                height="64"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                class="feather feather-book-open text-muted mb-3"
                                style="opacity: 0.5;"
                            >
                                <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
                                <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
                            </svg>
                            <p class="text-muted">Nenhum curso encontrado.</p>
                        </div>

                        <!-- Courses List -->
                        <div v-else class="row">
                            <div 
                                v-for="curso in cursosFiltrados" 
                                :key="curso.id"
                                class="col-lg-3 col-md-6 mb-lg-0 mb-4"
                            >
                                <div class="card curso-card" @click="navigateToCurso(curso.id)">
                                    <div class="curso-image-wrapper">
                                        <img 
                                            :src="curso.imagem" 
                                            :alt="curso.titulo" 
                                            class="card-img-top"
                                            @error="handleImageError($event)"
                                        />
                                        <div class="curso-badge" v-if="curso.destaque">
                                            <span class="badge badge-primary">Destaque</span>
                                        </div>
                                        <div class="curso-progress-overlay" v-if="curso.progresso > 0">
                                            <div class="progress progress-sm">
                                                <div 
                                                    class="progress-bar bg-primary" 
                                                    :style="{ width: curso.progresso + '%' }"
                                                ></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="fq-rating mb-2" v-if="curso.avaliacao > 0">
                                            <svg 
                                                v-for="i in 5" 
                                                :key="i" 
                                                xmlns="http://www.w3.org/2000/svg" 
                                                width="18"
                                                height="18" 
                                                viewBox="0 0 24 24" 
                                                fill="none" 
                                                stroke="currentColor"
                                                stroke-width="2" 
                                                stroke-linecap="round" 
                                                stroke-linejoin="round"
                                                class="feather feather-star"
                                                :class="{ 'checked': i <= Math.round(curso.avaliacao) }"
                                            >
                                                <polygon
                                                    points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2">
                                                </polygon>
                                            </svg>
                                            <span class="avaliacao-text">{{ curso.avaliacao.toFixed(1) }}</span>
                                        </div>
                                        <div v-else class="fq-rating mb-2">
                                            <span class="text-muted" style="font-size: 13px;">Sem avaliações</span>
                                        </div>
                                        <h5 class="card-title">{{ curso.titulo }}</h5>
                                        <p class="card-text">{{ truncarDescricao(curso.descricao) }}</p>
                                        <div class="curso-meta">
                                            <div class="meta-item">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-play-circle">
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <polygon points="10 8 16 12 10 16 10 8"></polygon>
                                                </svg>
                                                <span>{{ curso.totalAulas }} aulas</span>
                                            </div>
                                            <div class="meta-item">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-clock">
                                                    <circle cx="12" cy="12" r="10"></circle>
                                                    <polyline points="12 6 12 12 16 14"></polyline>
                                                </svg>
                                                <span>{{ curso.duracao }}</span>
                                            </div>
                                        </div>
                                        <div class="curso-footer">
                                            <span class="curso-nivel" :class="'nivel-' + curso.nivel.toLowerCase()">
                                                {{ curso.nivel }}
                                            </span>
                                            <span class="curso-alunos">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-users">
                                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                                    <circle cx="9" cy="7" r="4"></circle>
                                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                                                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                                                </svg>
                                                {{ curso.totalAlunos }} alunos
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import "/src/assets/sass/pages/faq/faq.scss";
import "/src/assets/sass/pages/helpdesk.scss";
import { useRouter } from 'vue-router';
import { ref, computed, onMounted, watch } from 'vue';
import { useMeta } from "/src/composables/use-meta";
import { useCursoStore } from '@/stores/curso';
import { DEFAULT_COURSE_IMAGE_URL, applyImageFallbackOnce } from '@/utils/imageFallback';

useMeta({ title: "Tela inicial" });

const router = useRouter();
const cursoStore = useCursoStore();
const searchTimeout = ref(null);

const onSearchInput = (e) => {
    cursoStore.setHeaderSearchQuery(e.target.value);
};

// Computed para cursos filtrados (retorna os cursos do store)
const cursosFiltrados = computed(() => {
    return cursoStore.cursos;
});

// Reagir à busca (com debounce)
watch(() => cursoStore.headerSearchQuery, () => {
    if (searchTimeout.value) clearTimeout(searchTimeout.value);
    searchTimeout.value = setTimeout(async () => {
        try {
            await cursoStore.fetchCursos({
                search: cursoStore.headerSearchQuery,
                page: 1
            });
        } catch (error) {
            console.error('Erro ao filtrar cursos:', error);
        }
    }, 400);
}, { immediate: false });

// Carregar cursos ao montar
onMounted(async () => {
    try {
        await cursoStore.fetchCursos({
            search: cursoStore.headerSearchQuery,
            page: 1
        });
    } catch (error) {
        console.error('Erro ao carregar cursos:', error);
    }
});

const navigateToCurso = (cursoId) => {
    router.push(`/curso/${cursoId}`);
};

const truncarDescricao = (texto, limite = 150) => {
    if (!texto) return '';

    const descricao = String(texto).trim();
    if (descricao.length <= limite) return descricao;

    const trecho = descricao.slice(0, limite + 1);
    const ultimoEspaco = trecho.lastIndexOf(' ');
    const textoCortado = ultimoEspaco > 0 ? trecho.slice(0, ultimoEspaco) : trecho.slice(0, limite);

    return `${textoCortado.trimEnd()}...`;
};

// Tratamento de erro de imagem (evita loop: /src/assets não existe no build)
const handleImageError = (event) => {
    applyImageFallbackOnce(event, DEFAULT_COURSE_IMAGE_URL);
};
</script>

<style scoped>
/* Hero com busca estilo Udemy */
.cursos-hero {
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    margin-bottom: 2rem;
    padding: 2.5rem 1rem 3rem;
    background: linear-gradient(180deg, #f0f4ff 0%, #e8eeff 50%, #e0e8ff 100%);
    border-bottom: 1px solid rgba(67, 97, 238, 0.12);
}
.cursos-hero-inner {
    max-width: 720px;
    margin: 0 auto;
    text-align: center;
}
.cursos-hero-title {
    font-size: clamp(1.75rem, 4vw, 2.25rem);
    font-weight: 700;
    color: #1e293b;
    margin: 0 0 0.5rem;
    letter-spacing: -0.02em;
    line-height: 1.2;
}
.cursos-hero-subtitle {
    font-size: 1.05rem;
    color: #64748b;
    margin: 0 0 1.75rem;
    line-height: 1.5;
}
.cursos-hero-search-wrap {
    display: flex;
    align-items: center;
    max-width: 560px;
    margin: 0 auto;
    background: #fff;
    border-radius: 12px;
    padding: 0 18px;
    height: 56px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.06);
    border: 1px solid #e2e8f0;
    transition: box-shadow 0.2s, border-color 0.2s;
}
.cursos-hero-search-wrap:focus-within {
    border-color: #6366f1;
    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2), 0 0 0 3px rgba(99, 102, 241, 0.12);
}
.cursos-hero-search-icon {
    display: flex;
    align-items: center;
    margin-right: 14px;
    color: #64748b;
    flex-shrink: 0;
}
.cursos-hero-search-input {
    flex: 1;
    border: none;
    background: transparent !important;
    font-size: 16px;
    color: #1e293b;
    outline: none;
    min-width: 0;
    -webkit-appearance: none;
    appearance: none;
}
.cursos-hero-search-input::placeholder {
    color: #94a3b8;
}
@media (max-width: 575px) {
    .cursos-hero {
        padding: 2rem 1rem 2.5rem;
    }
    .cursos-hero-search-wrap {
        height: 52px;
        padding: 0 14px;
    }
}

/* Dark mode – hero */
body.dark .cursos-hero {
    background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
    border-bottom-color: rgba(71, 85, 105, 0.5);
}
body.dark .cursos-hero-title {
    color: #f1f5f9;
}
body.dark .cursos-hero-subtitle {
    color: #94a3b8;
}
body.dark .cursos-hero-search-wrap {
    background: #334155;
    border-color: #475569;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.3);
}
body.dark .cursos-hero-search-wrap:focus-within {
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.25);
}
body.dark .cursos-hero-search-icon {
    color: #94a3b8;
}
body.dark .cursos-hero-search-input {
    color: #e2e8f0;
}
body.dark .cursos-hero-search-input::placeholder {
    color: #64748b;
}

/* ========== Skeleton loading (index) ========== */
.cursos-index-skeleton {
    margin-top: 0;
}
.skeleton-card {
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #e0e6ed;
    background: #fff;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.skeleton-card-image {
    width: 100%;
    height: 200px;
    flex-shrink: 0;
}
.skeleton-card-body {
    padding: 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.skeleton-rating {
    height: 20px;
    width: 72px;
    border-radius: 6px;
}
.skeleton-title {
    height: 22px;
    border-radius: 6px;
    max-width: 95%;
}
.skeleton-text {
    height: 14px;
    border-radius: 6px;
    max-width: 100%;
}
.skeleton-text.short {
    max-width: 75%;
}
.skeleton-meta {
    display: flex;
    gap: 16px;
    margin-top: 4px;
}
.skeleton-meta-item {
    height: 14px;
    width: 64px;
    border-radius: 6px;
}
.skeleton-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: auto;
    padding-top: 15px;
    border-top: 1px solid #e0e6ed;
}
.skeleton-badge {
    height: 24px;
    width: 70px;
    border-radius: 20px;
}
.skeleton-alunos {
    height: 14px;
    width: 72px;
    border-radius: 6px;
}
.cursos-index-skeleton .skeleton {
    background: linear-gradient(
        90deg,
        #eef1f5 0%,
        #e8ecf2 45%,
        #f0f3f7 55%,
        #eef1f5 100%
    );
    background-size: 200% 100%;
    animation: skeleton-shimmer-index 1.4s ease-in-out infinite;
}
@keyframes skeleton-shimmer-index {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}

/* Skeleton dark mode (index) */
body.dark .skeleton-card {
    background: #1b2e4b;
    border-color: #3b3f5c;
}
body.dark .skeleton-footer {
    border-top-color: #3b3f5c;
}
body.dark .cursos-index-skeleton .skeleton {
    background: linear-gradient(
        90deg,
        #1e293b 0%,
        #334155 45%,
        #475569 55%,
        #1e293b 100%
    );
    background-size: 200% 100%;
    animation: skeleton-shimmer-index 1.4s ease-in-out infinite;
}

.curso-card {
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid rgba(224, 230, 237, 0.6) !important;
    border-radius: 12px;
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.curso-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
    border-color: #4361ee;
}

.curso-image-wrapper {
    position: relative;
    overflow: hidden;
    height: 200px;
}

.curso-card .card-img-top {
    transition: transform 0.3s ease;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.curso-card:hover .card-img-top {
    transform: scale(1.1);
}

.curso-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 2;
}

.curso-progress-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    padding: 8px 12px;
}

.curso-card .card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 20px;
}

.curso-card .card-title {
    transition: color 0.3s ease;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #3b3f5c;
}

.curso-card:hover .card-title {
    color: #4361ee;
}

.curso-card .card-text {
    color: #888ea8;
    font-size: 14px;
    margin-bottom: 15px;
    flex: 1;
}

.fq-rating {
    display: flex;
    align-items: center;
    gap: 4px;
}

.fq-rating svg {
    color: #e0e6ed;
}

.fq-rating svg.checked {
    color: #fbbf24;
    fill: #fbbf24;
}

.avaliacao-text {
    margin-left: 6px;
    font-size: 14px;
    font-weight: 600;
    color: #3b3f5c;
}

.curso-meta {
    display: flex;
    gap: 16px;
    margin-bottom: 15px;
    flex-wrap: wrap;
}

.meta-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    color: #888ea8;
}

.meta-item svg {
    width: 16px;
    height: 16px;
}

.curso-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 15px;
    border-top: 1px solid #e0e6ed;
    margin-top: auto;
}

.curso-nivel {
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.nivel-iniciante {
    background: #dbeafe;
    color: #1e40af;
}

.nivel-intermediário {
    background: #fef3c7;
    color: #92400e;
}

.nivel-avançado {
    background: #fce7f3;
    color: #9f1239;
}

.curso-alunos {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #888ea8;
}

.curso-alunos svg {
    width: 14px;
    height: 14px;
}

/* Dark mode */
:deep(.dark) .curso-card {
    background: #1b2e4b;
    border-color: rgba(59, 63, 92, 0.6);
}

:deep(.dark) .curso-card:hover {
    border-color: #4361ee;
    box-shadow: 0 10px 25px rgba(67, 97, 238, 0.2);
}

:deep(.dark) .curso-card .card-title {
    color: #e0e6ed;
}

:deep(.dark) .curso-card:hover .card-title {
    color: #4361ee;
}

:deep(.dark) .curso-card .card-text {
    color: #888ea8;
}

:deep(.dark) .avaliacao-text {
    color: #e0e6ed;
}

:deep(.dark) .meta-item {
    color: #888ea8;
}

:deep(.dark) .curso-footer {
    border-top-color: #3b3f5c;
}

:deep(.dark) .curso-alunos {
    color: #888ea8;
}
</style>
